<template>
<div>
  <div >
    <van-swipe :autoplay="3000" style="height: 16rem; ">
      <van-swipe-item v-for="(imageItem, index) in swipeImageUrl" :key="index">
        <router-link :to="imageItem.imageToPath != 'null'?imageItem.imageToPath:$route.fullPath" >
        <img v-lazy="imageItem.imageUrl" alt="lazy不加载图片"/>
        </router-link>
      </van-swipe-item>
    </van-swipe>
  </div>
  <van-row :gutter="10">
    <van-col :span="24">
      <van-divider
          :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
      >
        <span style="font-size: larger;color: black;font-weight: bolder">工作时间：<span>{{workTime}}</span></span>
      </van-divider>
    </van-col>
  </van-row>
  <van-row style="text-align: center;">
    <van-col :span="24">
      <span style="font-weight: bolder;">QQ群：</span><span>{{custoermQq}}</span>
    </van-col>
  </van-row>
  <div style="margin: 10px;">
    <div class="header">
      <i class="iconfont icon-sound-filling"></i>
      <span>试客公告</span>
    </div>
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="height: 320px;">
      <van-cell @click="goToDetail(itm)" is-link v-for="(itm, indx) in noticList" :key="indx" center>
        <template #title>
        <span style="color: #444444;">
          <span v-show="itm.isNew" style="background-color: #04befe;color:white; width: 35px;padding: 5px;border-radius:5px ">最新</span>
          <span v-show="itm.isNeed" style="margin-left:5px;background-color: red;color:white; width: 35px;padding: 5px;border-radius:5px ">必读</span>
          <span v-show="itm.isTop" style="margin-left:5px;background-color: #04befe;color:white; width: 35px;padding: 5px;border-radius:5px;margin-right:5px;">置顶</span>
          <span>{{ itm.noticeTitle }}</span>
          <div >{{ itm.createTime }}</div>
        </span>
        </template>
      </van-cell>
      </van-pull-refresh>
    </div>
  </div>
  <!-- 试客公告弹窗：一次只弹一条，关闭当前这条后接着弹出下一条，直到全部展示完 -->
  <van-dialog v-if="customerNotic.length > 0"
              v-model="isShow"
              @confirm="todayIsNotShow"
              @cancel="closeNotice"
              @closed="onDialogClosed"
              confirm-button-text="今日不再展示"
              :show-confirm-button="true"
              :show-cancel-button="true">
    <div style="margin: 3%;">
      <van-row>
        <van-col :span="22" style="margin: 1%; margin-top: 2%;">
          <div style="font-weight: bolder">{{ customerNotic[0].noticeTitle }}</div>
          <span style="font-size: xx-small">{{customerNotic[0].createTime}}</span>
        </van-col>
      </van-row>
      <van-row>
        <van-col :span="22" style="margin: 1%">
          <div v-html="customerNotic[0].noticeContent"></div>
        </van-col>
      </van-row>
    </div>
  </van-dialog>
  <!--<RejectExtraReviewDialog :showedialog="showReject" :list="extraOrderList" @rejectExtraReview="rejectExtra"></RejectExtraReviewDialog>-->
</div>
</template>

<script>
import {queryNotice, updateNotice, updateNoticeIsNotToday} from "../../api/system/sys_personcenter";
import {queryCustomeSetting} from "../../api/system/sys_plateform";
import {queryExtraOrder, rejectExtraReviewOperInfo} from "../../api/system/mobile_taskorder";
import {Dialog} from "vant";
import RejectExtraReviewDialog from "../../components/RejectExtraReviewDialog";
import {MessageBox, Toast} from "mint-ui";

export default {
  name: "firstpage",
  components: {RejectExtraReviewDialog},
  data(){
    return {
      swipeImageUrl: [
        {
          imageUrl:"https://ss0.baidu.com/94o3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/8c1001e93901213fc0dd7e1f54e736d12e2e9502.jpg",
          imageToPath: null
        },
        {
          imageUrl:"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.v3wall.com%2Fwallpaper%2F1280_800%2F1301%2F1280_800_20130110065136424279.jpg&refer=http%3A%2F%2Fwww.v3wall.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1627192568&t=b4db52821c404c07ee40538e15f10d42",
          imageToPath: null
        },
        {
          imageUrl:"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimages.ali213.net%2Fpicfile%2Fpic%2F2013%2F04%2F19%2F927_hsl%2520%287%29.jpg&refer=http%3A%2F%2Fimages.ali213.net&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1627192832&t=09f89cce3e4996de34f2c30137f83547",
          imageToPath: null
        }
      ],
      noticList:[],
      customerNotic:[],
      extraOrderList: [],
      showReject: false,
      isShow:false,
      isLoading: false,//数据是否加载完毕
      workTime: "9：00 - 20：00",
      custoermQq: "78671887",
    }
  },
  mounted() {
    this.$emit("titleChange", "首页");
    console.log("firstPage")
    this.getData();
    queryCustomeSetting().then(res=>{
      if (res.success){
        this.swipeImageUrl = [];
        this.swipeImageUrl.push({imageUrl:res.data.firstImageUrl, imageToPath: res.data.firstImageToPath});
        this.swipeImageUrl.push({imageUrl:res.data.secondImageUrl,imageToPath: res.data.secondImageToPath});
        this.swipeImageUrl.push({imageUrl:res.data.thirdImageUrl,imageToPath: res.data.thirdImageToPath});
        this.workTime = res.data.workTime;
        this.custoermQq = res.data.customerQq;
      }
    });

    queryExtraOrder().then(res=>{
      if (res.success &&res.data!=null&&res.data.length>0){
        Dialog.confirm({
          title: '追评',
          message: '你有追评订单，请处理。',
          confirmButtonText: "追加评价",
          //cancelButtonText: "拒绝评价"
          showCancelButton:false
        }).then(() => {
          // on close
          this.$router.push({path: '/home/usertaskmgelist', query:{status:10}});
        }).catch(()=>{
          console.log("cancel")
          //this.extraOrderList = res.data;
          //this.showReject = true
        });
      }
    })
  },
  computed:{
  },
  methods:{
    /*
    rejectExtra(order){
      rejectExtraReviewOperInfo(order).then(res=>{
        if (res.success){
          this.showReject = false
          Toast(res.data);
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
     */
    // 点击“今日不再展示”：把当前这条公告记录为今日不再展示
    // 弹窗随后会自动收起，收起动画结束后在 onDialogClosed 里弹出下一条
    todayIsNotShow(){
      if (this.customerNotic.length === 0){
        return;
      }
      const cur = this.customerNotic[0];
      cur.isNotToday = true;
      updateNoticeIsNotToday(cur.id).then(()=>{
        // 已记录成功，无需重新拉取列表，避免公告重复弹出
      }).catch(()=>{
        console.log("updateNoticeIsNotToday error");
      });
    },
    // 点击取消/关闭：直接收起当前这条（不设置为今日不再展示）
    closeNotice(){
      // 弹窗会自行关闭，在 onDialogClosed 中继续弹出下一条
    },
    // 当前弹窗完全关闭后：移除已处理的一条，若还有公告则接着弹出下一条
    onDialogClosed(){
      this.customerNotic.shift();
      if (this.customerNotic.length > 0){
        this.isShow = true;
      }
    },
    onRefresh() {
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
        this.count++;
      }, 1000);
    },
    // 从公告列表里挑出需要弹窗展示的公告，依次展示
    isNeedShow(){
      if (this.customerNotic.length > 0){
        return;
      }
      this.customerNotic = this.noticList.filter(item => item.isShow && !item.isNotToday);
      if (this.customerNotic.length > 0){
        this.isShow = true;
      }
    },
    getData(){
      queryNotice({searchKeyWord:null}, {pageNum:1, pageSize:20}).then(res=>{
        if (res.success){
          this.noticList = res.data.records;
          this.isNeedShow();
        }
      });
    },
    goToDetail(val){
      console.log(val)
      this.$router.push({path:"/home/vipmembercon",query:{customerNotic:val}});
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}
div .mint-swipe-item{
  object-fit: fill;
}
.header{
  line-height: 33px;
  border-bottom: 1px dashed #acacac;
}
img{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.div_row{
  display: flex;
  flex-flow: column nowrap;
  justify-content: left;
  .div_col{
    width: 20%;
  };
  .div_col:first-child{
    background-color: #acacac;
  }
}
</style>
